import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useFYspListQuery, useFYspjdListQuery } from '../../store/DianShangYeWuApi';
function ExpenseNodeEdit(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useFYspListQuery({fy_sp_fy_id:props.fy_id},{skip:!props.fy_id})
    const {data:spjdData, isSuccess:spjdIsSuccess} = useFYspjdListQuery({fy_spjd_qy_id:props.qy_id,fy_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            const sortedData = [...data.Result].sort((a, b) => {
                return a.fy_sp_xuhao - b.fy_sp_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.fy_sp_jd_name}</span>       ,
                content:<Space orientation='vertical' size={1}>
                                <span>
                                {(item.fy_sp_state==='3' && item.fy_sp_jd_name==='抄送') && <span style={{color:"#000"}}>未读：</span>}
                                {(item.fy_sp_state==='3' && item.fy_sp_jd_name==='审批') && <span style={{color:"green"}}>已同意{item.fy_sp_content? '：'+item.fy_sp_content :''}</span>}
                                {(item.fy_sp_state==='4' && item.fy_sp_jd_name==='审批') && <span style={{color:"red",fontWeight:"bold"}}>已驳回{item.fy_sp_content? '：'+item.fy_sp_content :''}</span>}
                            </span>
                            <span style={(item.fy_sp_state==='3' || item.fy_sp_state==='4' || item.fy_sp_state==='5') ? {color:'#000'} : {}}>{item.fy_sp_yh_name} {item.fy_sp_state_time} </span>
                        </Space>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.fy_uname} {props.fy_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.fy_uname} {props.fy_state_time}</span>,
            },...arr]);
        }else{
            if(spjdIsSuccess && spjdData.Status === 'success'){
                const sortedData = [...spjdData.Result].sort((a, b) => {
                    return a.fy_spjd_xuhao - b.fy_spjd_xuhao;
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.fy_spjd_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.fy_spjd_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.fy_uname} {props.fy_ctime}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.fy_uname}{props.fy_state_time}</span>,
                },...arr]);
            }else{
                setItems([]);
            }
        }
        
        
    },[data, isSuccess,spjdData, spjdIsSuccess,props])
    return (
        <Steps 
            items={items} 
            current={1} 
            size="small" 
            titlePlacement="vertical"
        />
    )
}

export default ExpenseNodeEdit